/**
 * @flow
 * @relayHash c7ba7732d6c7f4369ad298cb56bcfa69
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type BulkDeductQtyModalQueryVariables = {|
  lotNumbers?: ?$ReadOnlyArray<string>
|};
export type BulkDeductQtyModalQueryResponse = {|
  +lots: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: {|
        +id: string
      |}
    |}>
  |}
|};
export type BulkDeductQtyModalQuery = {|
  variables: BulkDeductQtyModalQueryVariables,
  response: BulkDeductQtyModalQueryResponse,
|};
*/


/*
query BulkDeductQtyModalQuery(
  $lotNumbers: [String!]
) {
  lots(first: 1, lotNumbers: $lotNumbers) {
    edges {
      node {
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "lotNumbers",
    "type": "[String!]",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "lots",
    "storageKey": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 1
      },
      {
        "kind": "Variable",
        "name": "lotNumbers",
        "variableName": "lotNumbers"
      }
    ],
    "concreteType": "LotConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "LotEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Lot",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "BulkDeductQtyModalQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "BulkDeductQtyModalQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "BulkDeductQtyModalQuery",
    "id": null,
    "text": "query BulkDeductQtyModalQuery(\n  $lotNumbers: [String!]\n) {\n  lots(first: 1, lotNumbers: $lotNumbers) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'cf825cab52e723c701c34844749e64a0';
module.exports = node;
